import Vue from 'vue';
import {
  CABECALHO,
  lerTokenDaUrl,
  hashSemToken,
  lerDadosDoToken,
  situacaoDoToken,
  deveEnviarCabecalho,
  ehErroDePrevia,
} from './previaStudioNucleo';

// Prévia do Studio nesta aba: o token fica só na sessionStorage da aba e nunca vai para o
// localStorage do frontend. Sem token, nada daqui altera o funcionamento do app.

const CHAVE_SESSAO = 'clic-previa-studio';

export const estadoPrevia = Vue.observable({
  ativa: false, autor: '', expiraEm: null, avisos: [], aviso: '',
});

let token = null;
let subdominioDaPagina = null;

const lerSessao = () => {
  try {
    return sessionStorage.getItem(CHAVE_SESSAO);
  } catch (erro) {
    return null;
  }
};

const gravarSessao = (valor) => {
  try {
    if (valor) sessionStorage.setItem(CHAVE_SESSAO, valor);
    else sessionStorage.removeItem(CHAVE_SESSAO);
    return true;
  } catch (erro) {
    return false;
  }
};

const desativar = (aviso) => {
  token = null;
  gravarSessao(null);
  Object.assign(estadoPrevia, { ativa: false, avisos: [], aviso: aviso || '' });
};

const MENSAGENS = {
  expirada: 'A prévia do Studio expirou: abra de novo pelo Studio. Você está vendo a produção.',
  invalida: 'Link de prévia inválido: abra de novo pelo Studio. Você está vendo a produção.',
  outroTenant: 'Este link de prévia é de outro ambiente. Você está vendo a produção.',
};

export const iniciar = (subdominio) => {
  subdominioDaPagina = subdominio;
  const daUrl = lerTokenDaUrl(window.location.hash);
  if (daUrl) {
    gravarSessao(daUrl);
    const { pathname, search, hash } = window.location;
    window.history.replaceState(window.history.state, '', `${pathname}${search}${hashSemToken(hash)}`);
  }
  const candidato = daUrl || lerSessao();
  if (!candidato) return;

  const situacao = situacaoDoToken(candidato, { subdominio, agoraMs: Date.now() });
  if (situacao !== 'ativa') {
    desativar(MENSAGENS[situacao]);
    return;
  }
  token = candidato;
  const dados = lerDadosDoToken(candidato);
  Object.assign(estadoPrevia, {
    ativa: true, autor: dados.nome || dados.login, expiraEm: new Date(dados.exp * 1000), aviso: '',
  });
};

export const ativa = () => Boolean(token);

export const obterFrontend = (axios) => axios
  .get(`${process.env.VUE_APP_BACKEND_URL}/api/sys/previa/frontend`, { headers: { [CABECALHO]: token } })
  .then((retorno) => {
    const previa = (retorno.data && retorno.data.previa) || {};
    estadoPrevia.avisos = previa.avisos || [];
    return retorno.data.dados;
  })
  .catch((erro) => {
    desativar(
      ehErroDePrevia(erro)
        ? `${erro.response.data.mensagem} Você está vendo a produção.`
        : 'Não foi possível carregar a prévia do Studio. Você está vendo a produção.',
    );
    return null;
  });

export const cabecalhoPara = ({ url, baseURL }) => {
  if (!token) return {};
  const destino = { url, baseURL, origem: window.location.origin };
  return deveEnviarCabecalho(destino, subdominioDaPagina) ? { [CABECALHO]: token } : {};
};

export const tratarErro = (erro) => {
  if (token && ehErroDePrevia(erro)) {
    estadoPrevia.ativa = false;
    estadoPrevia.aviso = `${erro.response.data.mensagem}`;
  }
};

export const sair = () => {
  desativar('');
  window.location.reload();
};

export const fecharAviso = () => {
  if (token) sair();
  else estadoPrevia.aviso = '';
};
